<template>
  <div class="h100-40 h-scroll">
    <ejs-grid
      ref="grid"
      height="calc(100% - 0px)"
      :dataSource="data"
      :allowReordering="true"
      :allowResizing="true"
    >
     <e-columns :columns='shipColumns' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'>
        <e-column field='name' minWidth='10' :headerText='$t("NSMF.instanceName")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='sST' minWidth='10' :headerText='$t("NSMF.sst")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='sSTFormat'></e-column>
        <e-column field='sd' minWidth='10' :headerText='$t("NSMF.sd")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'  :formatter='sdFormat'></e-column>
        <e-column field='mcc' minWidth='10' :headerText='$t("NSMF.mcc")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='mccFormat'></e-column>
        <e-column field='mnc' minWidth='10' :headerText='$t("NSMF.mnc")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='mncFormat'></e-column>
        <e-column field='maxNumberOfUEs' minWidth='10' :headerText='$t("NSMF.maxNumberofUEs")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='caps' minWidth='10' :headerText='$t("NSMF.caps")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='throughPut' minWidth='10' :headerText='$t("NSMF.gbps")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='numberOfStation' minWidth='10' :headerText='$t("NSMF.gnbNum")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='administrativeState' minWidth='10' :headerText='$t("NSMF.administrativeState")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='ativeStateFormat'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager
      ref="pager"
      @click="getNSIListData()"
      :pageSize="page.pageSize"
      :currentPage="page.pageNo"
      :totalRecordsCount="page.totalCount"
      :pageCount="page.pageCount"
    ></ejs-pager>
    <CustomDialog
      ref="monitorDialog"
      :element="dialog.element.monitorDialogSetting"
      :styles="dialog.element.monitorDialogSetting.styles"
    >
      <template v-slot:dialog-content>
        <NSIMonitor ref="monitorContent"></NSIMonitor>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import {
  Reorder,
  Resize,
  ExcelExport,
  ContextMenu
} from "@syncfusion/ej2-vue-grids";
import CustomDialog from "../../common/CustomDialog";
import NSIMonitor from "./NSIMonitor";
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: "nsiTable",
  components: {
    CustomDialog,
    NSIMonitor
  },
  data() {
    return {
      data: [],
      page: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0,
        pageCount: 10
      },dialog: {
        element: {
          monitorDialogSetting: {
            styles: {
              width: "1220px",
              height: "767px",
              model: true,
              visible: false
            },
            target: "#app",
            title: this.$t("NSMF.nsmfMonitor"),
            refName: "add",
            isClose: true,
            buttonGroup: [
              {
                click: this.dialogHide,
                buttonModel: { content: this.$t("Common.cancel") }
              }
            ]
          }
        }
      },
      shipColumns: [
        {
          field: "ShippedDate",
          headerText: "Shipped Date",
          format: "yMd",
          textAlign: "Right",
          width: 150,
          minWidth: 10
        },
        {
          field: "ShipCountry",
          headerText: "Ship Country",
          width: 150,
          minWidth: 10
        }
      ]
    };
  },
  provide: {
    grid: [Reorder, Resize, ExcelExport, ContextMenu]
  },
  methods: {
    sSTFormat(grids, data) {
      if (null !== data && undefined !== data && data.sST === "1") {
        return "eMBB";
      } else if (null !== data && undefined !== data && data.sST === "2") {
        return "URLLC";
      } else if (null !== data && undefined !== data && data.sST === "3") {
        return "MIoT";
      } else {
        return "V2X";
      }
    },
    //根据任务UNM-600修改：添加一列激活状态，
    ativeStateFormat(grids, data) {
      if (data.administrativeState || data.administrativeState === 0) {
        return this.$t(`NSMF.administrativeState${data.administrativeState}`);
      }
      return '';
    },
    mccFormat(grids, data) {
      return data.pLMNList.split(":")[0];
    },
    mncFormat(grids, data) {
      return data.pLMNList.split(":")[1];
    },
    sdFormat(grids, data) {
      return data.sNSSAIList.split(":")[1];
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.no_checked")}`
        });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.too_many_checked")}!`
        });
        return false;
      }
      return selectedRecords;
    },
    getNSIListData() {
      // 获取表格数据
      const This = this;
      This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      const params = {
        pageNo: parseInt(This.page.pageNo, 10),
        pageSize: parseInt(This.page.pageSize, 10)
      };
      This.$axios
        .get(
          `/lte/ems/networkSlice/listServiceSlice?pageNo=${params.pageNo}&pageSize=${params.pageSize}`
        )
        .then(response => {
          if (
            response &&
            response.status === 200 &&
            response.data.errorCode === "SUCCESS"
          ) {
            const result = response.data.resultVal;
            This.page.totalCount = result.totalCount;
            This.data = result.result;
          } else {
            EventBus.$emit("toast", {
              type: "error",
              content: response.data.errorString
            });
          }
        });
    },
    deleteNSI() {
      // 删除任务
      const checkedDataList = this.getCheckedData(false);
      if (checkedDataList) {
        const checkedData = checkedDataList[0];
        this.$layer.confirm({
          msg: this.$t("NSMF.deleteNSI"),
          btn1: { msg: this.$t("Common.cancel") },
          btn2: {
            msg: this.$t("Common.confirm"),
            func: () => {
              this.$loading.showLoadding(this.$t('DeployManagement.deleteLoad'));
              this.$axios
                .post(
                  `/lte/ems/networkSlice/deleteNSI/${checkedData.id}`
                )
                .then(response => {
                  if (
                    response &&
                    response.status === 200 &&
                    response.data.errorCode === "SUCCESS"
                  ) {
                    EventBus.$emit("toast", {
                      type: "success",
                      content: this.$t("Common.tips.success")
                    });
                    this.getNSIListData();
                  } else {
                    EventBus.$emit("toast", {
                      type: "error",
                      content: response.data.errorString
                    });
                  }
                 this.$loading.hideLoadding();
                }).catch(err => {
               this.$loading.hideLoadding();
               EventBus.$emit("toast", {type: "warning",content: `${this.$t("Common.tips.failure")}`});                
               });
            }
          }
        });
      }
    },
    dialogHide() {
      this.$refs.monitorDialog.clear();
      this.$refs.monitorDialog.close();
    },
    monitorNSI(){
      const checkedDataList = this.getCheckedData(false);
      if (checkedDataList) {
        const checkedData = checkedDataList[0];
        this.$refs.monitorContent.findMonitorNSI(checkedData.id);
        this.$refs.monitorDialog.show();
      }
    },
    activateNSI() {
      // 激活
      const checkedDataList = this.getCheckedData(false);
      if (checkedDataList) {
        const checkedData = checkedDataList[0];
        this.$layer.confirm({
          msg: this.$t("NSMF.activateNSIInfo"),
          btn1: { msg: this.$t("Common.cancel") },
          btn2: {
            msg: this.$t("Common.confirm"),
            func: () => {
              this.$axios
                .post(`/lte/ems/networkSlice/activateNSI/${checkedData.id}`)
                .then(response => {
                  if (
                    response &&
                    response.status === 200 &&
                    response.data.errorCode === "SUCCESS"
                  ) {
                    EventBus.$emit("toast", {
                      type: "success",
                      content: this.$t("NSMF.success")
                    });
                    this.getNSIListData();
                  } else {
                    EventBus.$emit("toast", {
                      type: "error",
                      content: response.data.errorString
                    });
                  }
                });
            }
          }
        });
      }
    },
    deactivateNSI() {
      // 失活
      const checkedDataList = this.getCheckedData(false);
      if (checkedDataList) {
        const checkedData = checkedDataList[0];
        this.$layer.confirm({
          msg: this.$t("NSMF.deactivateNSIInfo"),
          btn1: { msg: this.$t("Common.cancel") },
          btn2: {
            msg: this.$t("Common.confirm"),
            func: () => {
              this.$axios
                .post(`/lte/ems/networkSlice/deactivateNSI/${checkedData.id}`)
                .then(response => {
                  if (
                    response &&
                    response.status === 200 &&
                    response.data.errorCode === "SUCCESS"
                  ) {
                    EventBus.$emit("toast", {
                      type: "success",
                      content: this.$t("NSMF.success")
                    });
                    this.getNSIListData();
                  } else {
                    EventBus.$emit("toast", {
                      type: "error",
                      content: response.data.errorString
                    });
                  }
                });
            }
          }
        });
      }
    }
  },
  mounted() {
    this.getNSIListData();
  }
};
</script>
